// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__m+gO5","slider":"ToggleSwitch_slider__zAI24"};